import controller from './controller';

export default {
  controller,
};
